import React, { useState } from "react";
import { useForm } from "react-hook-form";
import CustomInput from "../UIKits/CustomInput/CustomInput";
import CustomDropDown from "../UIKits/CustomDropdown/CustomDropdownWitoutControl";
import { ButtonPrimary } from "../Button/Button";
import { IProcessSpecialToken, } from "../../types/buypower.type";

interface SpecialTokensFormProps {
  onSubmit?: (data: IProcessSpecialToken) => void;
  isLoading?: boolean;
}



const SpecialTokensForm: React.FC<SpecialTokensFormProps> = ({
  onSubmit,
  isLoading = false,
}) => {
  const [validationErrors, setValidationErrors] = useState<{
    meterNumber?: string;
    tokenType?: string;
    reason?: string;
  }>({});

  const {
    control,
    handleSubmit,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      meterNumber: "",
      tokenType: "",
      reason: "",
    },
  });

  const tokenType = watch("tokenType");

  const tokenTypeOptions = [
    {
      label: "Key Change",
      value: "3",
    },
    {
      label: "Clear Tamper",
      value: "5",
    },
  ];

  const handleFormSubmit = (data: IProcessSpecialToken) => {
    const errors: typeof validationErrors = {};
    const meterDigitCount = data.meterNumber.match(/\d/g)?.length ?? 0;

    if (meterDigitCount < 3) {
      errors.meterNumber = "Meter number must contain at least 3 digits";
    }
    if (!data.tokenType) {
      errors.tokenType = "Select a token type";
    }
    if (!data.reason.trim()) {
      errors.reason = "Enter a reason";
    }

    setValidationErrors(errors);
    if (Object.keys(errors).length > 0) return;

    onSubmit?.({
      ...data,
      meterNumber: data.meterNumber.trim(),
      reason: data.reason.trim(),
    });
  };

  const inputFocusStyles = "focus:!border-[#00A859] focus:!shadow-[0_0_0_2px_rgba(0,168,89,0.2)] focus:!ring-0";

  return (
    <form
      onSubmit={handleSubmit(handleFormSubmit)}
      className="w-full lg:w-[450px] mx-auto"
    >
      {/* Meter Number */}
      <div className="mb-4">
        <CustomInput
          control={control}
          type="text"
          label="Meter number"
          labelStyle="!mb-1 !text-sm !font-medium !text-zinc-900"
          inputContainerStyle="!mb-0"
          inputStyles={`!h-10 !rounded-[10px] !border-zinc-200 !px-3 !py-1.5 !text-sm ${inputFocusStyles}`}
          placeholder=""
          name="meterNumber"
          errorMessage={validationErrors.meterNumber}
          handleOnChange={(event: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const meterDigitCount = event.currentTarget.value.match(/\d/g)?.length ?? 0;
            if (meterDigitCount >= 3) {
              setValidationErrors((current) => ({ ...current, meterNumber: undefined }));
            }
          }}
        />
      </div>

      {/* Token Type */}
      <div className="mb-4">
        <CustomDropDown
          name="tokenType"
          label="Token type"
          labelClassName="font-semibold !text-zinc-900"
          placeholder="Select token type"
          options={tokenTypeOptions}
          selectedValue={tokenType}
          onChange={(value) => {
            setValue("tokenType", value);
            setValidationErrors((current) => ({ ...current, tokenType: undefined }));
          }}
          className="h-10 [&_.ant-select-selector]:!rounded-[10px] [&.ant-select-focused_.ant-select-selector]:!border-[#00A859] [&.ant-select-focused_.ant-select-selector]:!shadow-[0_0_0_2px_rgba(0,168,89,0.2)]"
          
        />
        {validationErrors.tokenType && (
          <p role="alert" className="mt-1 text-xs text-[#FF3B30]">
            {validationErrors.tokenType}
          </p>
        )}
      </div>

      {/* Reason */}
      <div className="mb-4">

        <CustomInput
          control={control}
          name="reason"
          type="text"
          label="Reason"
          labelStyle="!mb-1 !text-sm !font-medium !text-zinc-900"
          placeholder=""
          inputProps={{ as: "textarea", rows: 4 }}
          inputContainerStyle="!mb-0"
          inputStyles={`!h-[95px] !min-h-[95px] !rounded-[10px] !border-zinc-200 !px-3 !py-2 !text-sm !resize-none ${inputFocusStyles}`}
          errorMessage={validationErrors.reason}
          handleOnChange={(event: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            if (event.currentTarget.value.trim()) {
              setValidationErrors((current) => ({ ...current, reason: undefined }));
            }
          }}
        />
      </div>

      {/* Submit */}
      <ButtonPrimary
        label="Process token"
        type="submit"
        isLoading={isLoading}
        width="100%"
      />
    </form>
  );
};

export default SpecialTokensForm;